// Id类型格式为
// Id(123)、Id('abc')、Id("abc")


import Declaration, { DeclarationFactory } from './base';

function isAcceptable(input: string) {
  return /(^\d+$)|(^[a-zA-Z0-9_-]+$)/.test(input);
}

class IdDeclaration extends Declaration implements DeclarationFactory {

  public declaration = 'Id';

  public generateRegExp() {
    return /(^Id\(\d+\))|(^Id\(\"[a-zA-Z0-9_-]+\"\))|(^Id\(\'[a-zA-Z0-9_-]+\'\))/;
  }

  public match(input: string) {
    const matched =
      input.match(/^(Id\((\d+)\))/) || // Id(123)
      input.match(/^(Id\((\".*?\")\))/) || // Id("ABC")
      input.match(/^(Id\((\'.*?\')\))/); // Id('ABC')

    if (matched) {
      const valueString = matched[2];
      const value = valueString.startsWith('"') || valueString.startsWith('\'') ?
        valueString.slice(1, -1) : Number(valueString);
      if (valueString.length > 0 && !Number.isNaN(value as number) && isAcceptable(String(value))) {
        return {
          type: 'Id',
          declaration: this.declaration,
          raw: matched[1],
          value,
          isAtom: true,
          isDeclaration: true
        };
      } else {
        throw this.generateInvalidError(matched[1], matched[2], '无效的Id值');
      }
    }
  }

}


export default new IdDeclaration();
